import React, { FC, useState, KeyboardEvent } from 'react';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import Clear from '@material-ui/icons/Clear';
import { useTranslation } from 'react-i18next';
import InputAdornment from '@material-ui/core/InputAdornment';

interface SearchProps {
  resetFunction: () => void;
  searchFunction: (term: string) => void;
  searchLabel: string;
}

const Search: FC<SearchProps> = ({ resetFunction, searchFunction, searchLabel }) => {
  const [term, setTerm] = useState<string>('');
  const { t } = useTranslation();

  const keyUp = (event: KeyboardEvent<HTMLInputElement>): void => {
    if (event.keyCode === 13) {
      callSearch();
    }
  };

  const callSearch = (): void => searchFunction(term);
  const resetSearch = (): void => {
    setTerm('');
    resetFunction();
  };

  // TODO: refactor after moving products list to table
  return (
    <>
      <div style={{ display: 'flex', flex: 1 }}>
        <TextField
          placeholder={t(`label.search ${searchLabel}`)}
          onChange={e => setTerm(e.target.value)}
          value={term}
          fullWidth
          variant="outlined"
          InputProps={{
            'aria-label': 'search',
            onKeyUp: keyUp,
            endAdornment: (
              <InputAdornment position="end">
                <Clear onClick={resetSearch} style={{ cursor: 'pointer' }} />
              </InputAdornment>
            )
          }}
        />
        <IconButton aria-label="edit" color="primary" onClick={callSearch}>
          <SearchIcon />
        </IconButton>
      </div>
      {/*  ) : (
      <SearchDiv>
        <SearchIconDiv left>
          <SearchIcon onClick={callSearch} />
        </SearchIconDiv>
        <Input
          placeholder={t('label.search products')}
          inputProps={{ 'aria-label': 'search', onKeyUp: keyUp }}
          onChange={e => setTerm(e.target.value)}
          value={term}
        />
        <SearchIconDiv right>
          <Clear onClick={resetSearch} />
        </SearchIconDiv>
      </SearchDiv>
      )}  */}
    </>
  );
};

export { Search };
